import React from 'react';
import { Box, Divider, Spacer, Flex, Button } from '@chakra-ui/react';
import { Participants } from './participants';
import PropTypes from 'prop-types';
import { SettingsIcon } from '@chakra-ui/icons';
import { ChatContent } from './chatContent';
import { NoMessagesIcon } from '../../../images';
import { Trans } from 'react-i18next';

export const CommonChat = ({
  participants,
  setUserType,
  tempClickHandler,
  chatContent,
  removeUser,
  currentUserIsAdmin,
  openChatSettings,
  scrollRef,
}) => {
  return (
    <Box>
      <Flex pl={2}>
        <Box>
          <Participants
            tempClickHandler={tempClickHandler}
            participants={participants}
            setUserType={setUserType}
            removeUser={removeUser}
            currentUserIsAdmin={currentUserIsAdmin}
          />
        </Box>
        <Spacer />
        <Button bg="null" m={0} p={0} onClick={() => openChatSettings()}>
          <SettingsIcon w={6} h={6} mr={1} />
        </Button>
      </Flex>
      <Divider px={0} my={2} />

      <Box pl={2} height="40vh" overflow="scroll">
        <ChatContent mx={2} chatContent={chatContent} filter={(msg) => msg.to === undefined} />
        <Box ref={scrollRef}></Box>
      </Box>
      <Spacer />
      <Flex bg="yellow">
        <NoMessagesIcon /> <Trans i18nKey="chat.visibleToAll" />
      </Flex>
    </Box>
  );
};

CommonChat.propTypes = {
  chat: PropTypes.object,
  tempClickHandler: PropTypes.any,
  chatContent: PropTypes.array,
  participants: PropTypes.array,
  setUserType: PropTypes.func,
  removeUser: PropTypes.func,
  currentUserIsAdmin: PropTypes.bool,
  openChatSettings: PropTypes.func,
  scrollRef: PropTypes.object,
};
